import { AxiosResponse } from "axios";

import { CategoryModel, CategoryModelResponse } from "shared/types";

import BaseConverter from "./baseConverter";

export const convertCategories = (data: AxiosResponse<CategoryModelResponse>): CategoryModel[] =>
	BaseConverter.convert<CategoryModelResponse>(data).categories;
